import { BackButton, Header, Page, PageContent } from "@/components/page";
import { LoadingSpinner } from "@/components/spinner";
import { useActiveReservations } from "@/hooks/use-active-reservations";
import { useShop } from "@/hooks/use-shop";
import { useShopDetails } from "@frontend-common/hooks/use-shop-details";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";
import { MachineCard } from "./machine-selector-screen.$machine-type";
import { useAudioSlot } from "@/features/audio/kiosk-audio";
import { useFeatureFlags } from "@/lib/runtime-config";

export const Route = createFileRoute("/active-reservations-screen")({
  component: RouteComponent,
});

function RouteComponent() {
  useAudioSlot("page.active-reservations");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const activeReservations = useActiveReservations();
  const { data: shop } = useShop();
  const { data: details, isLoading } = useShopDetails(shop.shopId);
  const { washStartGuide } = useFeatureFlags();

  const machines = [
    ...(details?.machines.dryers ?? []),
    ...(details?.machines.washingMachines ?? []),
  ].filter((machine) =>
    activeReservations.data?.some((elem) => elem.machineId === machine.id),
  );

  return (
    <Page>
      <Header
        backArrowHref={
          <BackButton
            label={t("Vissza")}
            onClick={() => {
              navigate({ to: "/machine-type-selector-screen" });
            }}
          />
        }
      ></Header>
      <PageContent>
        <h1
          className={`mt-4 text-center text-[56px] px-18 font-bold leading-16`}
        >
          <Trans>Indítható foglalásaim</Trans>
        </h1>
        {isLoading && <LoadingSpinner />}
        <div className={`flex flex-wrap gap-6 px-16 justify-center mt-8`}>
          {machines.map((machine, i) => {
            return (
              <MachineCard
                machine={machine}
                key={i}
                onSelect={
                  washStartGuide
                    ? () =>
                        navigate({
                          to: "/payment/$machineType",
                          params: {
                            machineType:
                              machine.machineType === "szaritogep"
                                ? "drying-machines"
                                : "washing-machines",
                          },
                          search: { machineId: machine.id },
                        })
                    : undefined
                }
              />
            );
          })}
        </div>
      </PageContent>
    </Page>
  );
}
